import { render, staticRenderFns } from "./WrsViTextArea.vue?vue&type=template&id=c8da88e2&"
import script from "./WrsViTextArea.vue?vue&type=script&lang=js&"
export * from "./WrsViTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports